import { Button, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import React, { FC } from "react";
import SaveIcon from "@mui/icons-material/SaveOutlined";

interface FloatingSaveButtonProps {
  onClick: () => void;
  disabled: boolean;
  loading: boolean;
}

export const FloatingSaveButton: FC<FloatingSaveButtonProps> = ({
  onClick,
  disabled,
  loading,
}) => {
  const { t } = useTranslation();
  return (
    <Tooltip title={t("utils.actions.save")} arrow>
      <span>
        <Button
          aria-label={t("utils.actions.save")}
          className="min-w-0 p-2 sm:px-3 rounded shadow gap-2"
          color="primary"
          variant="contained"
          onClick={onClick}
          disabled={disabled}
          loading={loading}
        >
          <SaveIcon />
          <span className="hidden sm:inline">{t("utils.actions.save")}</span>
        </Button>
      </span>
    </Tooltip>
  );
};
